import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { ListItem } from 'material-ui/List';

import ContextIconMenu from '../Common/ContextIconMenu';
import IconButton from 'material-ui/IconButton';
import InfoIcon from 'material-ui/svg-icons/action/info';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

import * as Colors from 'material-ui/styles/colors';

import LocationActions from '../../actions/LocationActionCreator';

import ROLES from '../../constants/Roles';
import { compactAddressFields, formatAddress } from '../../utils/StringUtils';

const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    },

};

const getActions = (row) => [

        {
            link: `/dashboard/location/${row.id}`,
            label: 'Preview',
            icon: <InfoIcon />
        },
        {
            type:'divider'
        },
        {
            link: `/dashboard/location/${row.id}/edit`,
            label: 'Edit',
            icon: <EditIcon />,
            condition: {
                roles: [ROLES.ADMIN]
            }
        },
        {
            type: 'deleteDialog',
            dialogType: 'menu',
            value: row,
            title: 'Delete location',
            deleteAction: LocationActions.delete,
            message: (
                <span>
                        Are you sure to delete the location  "{row.name}" ?
                    </span>
            ),
            condition: {
                show:  row.sysStatus > 4,
                roles: [ROLES.ADMIN]
            }
        }
    ];


const LocationListItem = (props) => {

        const row = props.data;
        const infoLink = `/dashboard/location/${row.id}`;

        const actions = (props.actions || getActions(row));
        const address = [];
        if (row.venue) {
            address.push(row.venue);
        }
        const fullAddress = formatAddress(row, {fields: compactAddressFields});
        if (fullAddress) {
            address.push(fullAddress);
        }

        const flags = [];
        if ((!!row.status) && (row.status === 'unavailable')) {
            flags.push(<span key="a" className="flag-text">unavailable</span>);
        }

        const listItemProps = {
            key: row.id,
            style: style.listItem,
            primaryText: (
                <Link to={infoLink} className="primaryText">
                    {row.name}
                </Link>
            ),
            secondaryText: (
                <Link to={infoLink} className="secondaryText">
                    {flags}Capacity: {row.capacity}<br />
                    <em>{address.join(' - ')}</em>
                </Link>
            ),
            secondaryTextLines: 2,
        };

        return (
            <ListItem {...listItemProps}
                rightIcon={
                    <ContextIconMenu
                        actions={actions}
                        data={row}
                        menuStyle={style.menu}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}
                        iconButtonElement={
                            <IconButton touch={true} style={style.iconButton}>
                                <MoreVertIcon color={Colors.grey400} />
                            </IconButton>
                        }
                    />
                }
            />
        );
};

LocationListItem.contextTypes =  {
    auth: PropTypes.object.isRequired
};
export default LocationListItem;
